// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#root, html, body {
    height: 100%;
    width: 100%;
    margin: 0;
    max-width: 100%;
    max-height: 100vh !important;
}

* {
    box-sizing: border-box;
}

.center{
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-content: center;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

.mainArea{
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    
    height: 95% !important;
    width:  95% !important;
}

.title{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    height: auto;
    max-width: 100% !important;
    font-size: auto;
    font-weight: bold;
}

.chatArea{
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;
    height: 90% !important;
    max-width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/css/mainCss.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;IACX,SAAS;IACT,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;EACpB;;AAEF;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;;IAEf,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;IACtB,0BAA0B;AAC9B","sourcesContent":["#root, html, body {\r\n    height: 100%;\r\n    width: 100%;\r\n    margin: 0;\r\n    max-width: 100%;\r\n    max-height: 100vh !important;\r\n}\r\n\r\n* {\r\n    box-sizing: border-box;\r\n}\r\n\r\n.center{\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    flex-direction: column;\r\n    align-content: center;\r\n    align-items: center;\r\n    justify-content: center;\r\n    text-align: center;\r\n  }\r\n\r\n.mainArea{\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex-wrap: wrap;\r\n    \r\n    height: 95% !important;\r\n    width:  95% !important;\r\n}\r\n\r\n.title{\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex-wrap: wrap;\r\n    height: auto;\r\n    max-width: 100% !important;\r\n    font-size: auto;\r\n    font-weight: bold;\r\n}\r\n\r\n.chatArea{\r\n    display: flex;\r\n    flex-wrap: nowrap;\r\n    flex-direction: column;\r\n    height: 90% !important;\r\n    max-width: 100% !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
